import { WorkOrderImportResponse } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import { Divider, Modal, ModalProps, Radio, Typography } from 'antd';
import { useState } from 'react';
import ImportAudatexwebForm from './ImportAudatexwebForm';
import ImportCiliaForm from './ImportCiliaForm';
import ImportFileForm from './ImportFileForm';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import ImportJson from './ImportJson';
import { Group } from '@/components/_common';
import ImportHelpModal from './ImportHelpModal';
import { ImportComplementOrigin } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.enum';
import { importTypesOptions } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.constants';

export type WorkorderImportData = {
  SSLocaliza?: string;
  data: WorkOrderImportResponse;
  origin: ImportComplementOrigin;
};

export type ImportModalFormProps = {
  onClose: VoidFunction;
  onImported(data: WorkorderImportData): void;
  origin: ImportComplementOrigin;
};

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: VoidFunction;
  onImported(data: WorkorderImportData): void;
};

const WorkorderImportModal: React.FC<Props> = ({
  onCancel,
  onImported,
  ...props
}) => {
  const [importType, setImportType] = useState<ImportComplementOrigin>(
    ImportComplementOrigin.Soma,
  );

  const forms: Partial<Record<ImportComplementOrigin, JSX.Element>> = {
    [ImportComplementOrigin.Soma]: (
      <ImportFileForm
        origin={ImportComplementOrigin.Soma}
        key={ImportComplementOrigin.Soma}
        onClose={onCancel}
        onImported={onImported}
      />
    ),
    [ImportComplementOrigin.Cilia]: (
      <ImportCiliaForm
        origin={ImportComplementOrigin.Cilia}
        key={ImportComplementOrigin.Cilia}
        onClose={onCancel}
        onImported={onImported}
      />
    ),
    [ImportComplementOrigin.AudatexWeb]: (
      <ImportAudatexwebForm
        origin={ImportComplementOrigin.AudatexWeb}
        key={ImportComplementOrigin.AudatexWeb}
        onClose={onCancel}
        onImported={onImported}
      />
    ),
    [ImportComplementOrigin.I360]: (
      <ImportFileForm
        origin={ImportComplementOrigin.I360}
        key={ImportComplementOrigin.I360}
        onClose={onCancel}
        onImported={onImported}
      />
    ),
    [ImportComplementOrigin.JsonImport]: (
      <ImportJson
        origin={ImportComplementOrigin.JsonImport}
        key={ImportComplementOrigin.JsonImport}
        onClose={onCancel}
        onImported={onImported}
      />
    ),
  };

  return (
    <Modal
      {...props}
      open={
        props.open &&
        hasPermissions([Authorities.MOVIMENTATION_WORKORDER_IMPORT])
      }
      onCancel={onCancel}
      title={
        <Group gap={10}>
          <Typography.Text>Importação de orçamento</Typography.Text>

          {importType === ImportComplementOrigin.JsonImport && (
            <ImportHelpModal />
          )}
        </Group>
      }
      width={800}
      footer={null}
    >
      <span>Selecione um formato</span>

      <div>
        <Radio.Group
          defaultValue={importType}
          onChange={({ target }) => setImportType(target.value)}
          style={{ marginTop: 12 }}
          size="large"
        >
          {importTypesOptions.map((option) => (
            <Radio.Button key={option.origin} value={option.origin}>
              {option.name}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>

      <Divider />

      {forms[importType]}
    </Modal>
  );
};

export default WorkorderImportModal;
